export const CQL_FIND_ALL = 'cql.allRecords=1';
export const DEFAULT_FILTERS_NUMBER = 6;
export const USER_TOUCHED_STAFF_SUPPRESS_STORAGE_KEY = 'folio_user_touched_staff_suppress';
export const LIMIT_MAX = 5000;
export const OKAPI_TENANT_HEADER = 'X-Okapi-Tenant';
export const QUERY_KEY_LOCATIONS_FROM_ALL_TENANTS = 'locations-from-all-tenants';
export const DEFAULT_SORT = 'title';

export const segments = {
  instances: 'instances',
  holdings: 'holdings',
  items: 'items',
};
